import React from 'react';
import { Link } from 'react-router-dom';
import { useDevice } from 'components/DeviceContext.js';
import { Grid } from '@material-ui/core';
import iconCasa from 'imagens/Home.png';

// function HouseIcon(props) {
//     return (
//       <SvgIcon {...props}>
//         <path d="M3 9.5l9-7.5 9 7.5v9.5h-6v-6h-6v6h-6z" />
//         <path d="M0 0h24v24H0z" fill="none" />

//       </SvgIcon>
//     );
//   }

const LinksCabecalho = () => {
    const links = [
        { text: '', url: './' },
        { text: 'Convocação', url: './convocacao' },
        // { text: 'Campanha', url: './Campanha' },
        { text: 'Normativas', url: './normativas' },
        // { text: 'Parceiros', url: './parceiros' },
        { text: 'FAQ', url: './faq' },
        { text: 'Material Técnico', url: './materiais-tecnicos' },
        { text: 'Contato', url: './contato' },


    ];
    const { isMobile, isTablet,  isLaptop, isDesktop } = useDevice();

    return (
        <Grid container>
            {links.map((link, index) => (
                <Grid  key={index} item style={{ marginRight: isLaptop || isDesktop ? '0' : '1rem',marginTop: isLaptop || isDesktop ? '1.8em' : '1em'}}>
                    <Link
                    style={{
                        padding:'0 1em',
                        color: isMobile || isTablet ? 'var(--preto)' : 'var(--branco)',
                        fontSize: isLaptop ? '15px' : (isMobile ? '14px' : '20px'),
                        textTransform:'uppercase',
                        borderLeft: index === 0 ? 'none' : '1px solid var(--branco)'
                        }} to={link.url}>
                    {index === 0 ? <img src={iconCasa} alt='img' style={{ marginTop:'-0.6em', width: '34%' }} /> : null}
                        {link.text}
                    </Link>
                </Grid>
            ))}
        </Grid>
    );
}

export default LinksCabecalho;
